<div class="candidate-card-container" *ngIf="!isRowViewActive">
    <div *ngIf="!loadingFlag" class="main-box clearfix profile-box-menu" [ngClass]="{'candidate-card-vendor-card': candidateType === 'VENDOR_CANDIDATES', 'candidate-card-internal-card': candidateType == 'OWN_CANDIDATES' }">
        <div class="main-box-body clearfix">
            <div class="profile-box-notification"
                [ngClass]="{'candidate-card-active-bg': candidate.candidateActive,
                'candidate-card-passive-bg': candidate.candidatePassive,
                'candidate-card-inert-bg': candidate.candidateInert,
                'candidate-card-filled-joined-bg': candidate.anyJobMatchFilledOrJoined || candidate.candidateFilledOrJoinedToOwnJob}">
                <div *ngIf="showFilledOrJoinedHeader" class="pull-left candidate-job-card-notification-icon candidate-job-card-notification-icon-left"
                    popoverTitle="{{filledOrJoinedText}}ed"
                    placement="bottom"
                    [popover]="filledJoinedPopover"
                    containerClass="candidate-job-match-card-filled-joined-requisition-popover"
                    triggers="mouseenter"
                    container="body">
                    <a class="btn" id="filledJoinedInOtherJob">
                        <span>{{filledOrJoinedText}}ed</span>
                    </a>
                </div>
                <div class="dropdown pull-right candidate-card-notification-icon" tooltip="Notifications" container="body">
                    <a class="btn dropdown-toggle" data-toggle="dropdown" id="dropdownBell" (click)="showNotifications()">
                        <i class="fa fa-bell"></i>
                        <span class="count notification-count" *ngIf="numberOfNewNotifications > 0">{{numberOfNewNotifications}}</span>
                    </a>
                    <ul class="dropdown-menu notifications-list">
                        <li class="item">
                            <user-notifications *ngIf="showNotificationsFlag" height="200px" width="320px" [searchObject]="notificationsSearchObject" [viewAllFlag]="true" [notificationClicked]="isNotificationClicked"
                                viewAllMode="modal" context="candidateCard" [userNotificationControls]="userNotificationControls" [(numberOfNewNotifications)]="numberOfNewNotifications"
                                [showShortNotification]="true" [jobTypeList]="jobTypeList" [salaryDurationOptions]="salaryDurationOptions">
                            </user-notifications>
                        </li>
                    </ul>
                </div>
                <div tooltip="Activity Monitor" container="body" class="dropdown pull-right candidate-job-card-notification-icon">
                    <a class="btn dropdown-toggle" data-toggle="dropdown" id="activity-list" (click)="showRecentActivities()">
                        <i class="fa fa-list"></i>
                    </a>
                    <ul class="dropdown-menu candidate-activity-list">
                        <app-recent-activities [isActivityClicked]="isActivityClicked" *ngIf="showRecentActivitiesFlag"
                            [activityMap]="activityMap" [recentActivitiesControls]="recentActivitiesControls"
                            context="candidateCard" candidateId="{{candidateInfo.id}}"
                            (showAllCallback)="showAllActivityModal()">
                        </app-recent-activities>
                    </ul>
                </div>
                <div *ngIf="candidate.candidateStatus !== 'INERT' && candidate.bestMatchId !== null" tooltip="Peer Communication" container="body" class="pull-right candidate-job-card-notification-icon">
                    <a class="btn" (click)="launchCommunicationModal(true)" style="position:relative">
                        <i class="fa fa-comments"></i>
                        <span class="candidate-card-unread-message-count" *ngIf="candidate.unreadMessageCount > 0">
                            {{candidate.unreadMessageCount}}
                        </span>
                    </a>
                </div>
                <div tooltip="Peer Email" container="body" class="pull-right candidate-job-card-notification-icon">
                    <a class="btn" (click)="launchActionsModal('emailDocument')" style="position:relative">
                        <i class="fa fa-envelope-open"></i>
                    </a>
                </div>
                <div *ngIf="(isSuperUser || is4dot5UserAdmin) && candidate.totalJobMatchReRunCount && candidate.totalJobMatchReRunCount > 0"
                    tooltip="Rerun Scoring" placement="top" class="pull-right candidate-card-re-run-icon cursor-pointer">
                    <span id="reRunScore" (click)="launchActionsModal('runCandidateScore')">
                        <i class="fas fa-circle-notch"></i>
                    </span>
                </div>
            </div>
            <div class="profile-box-header candidate-card-header clearfix gery-bg"
                 [ngClass]="{'candidate-card-active-bg': candidate.candidateStatus === 'ACTIVE','candidate-card-passive-bg': candidate.candidateStatus === 'PASSIVE','candidate-card-inert-bg': candidate.candidateStatus === 'INERT','candidate-card-filled-joined-bg': showFilledOrJoinedOnCard, 'candidate-vendor-card-header': candidateType == 'VENDOR_CANDIDATES'}">
                <div class="candidate-card-name-div">
                    <img src="assets/app-content/img/people/4dot5-default-no-profile-pic.jpg" alt="{{candidate.name}}" class="candidate-card-img img-responsive pull-left"/>
                    <div>
                        <div class="cursor-pointer job-position">
                            <span class="candidate-card-wrap-candidate-name">
                                <i *ngIf="candidate.nameWarning !== ''" class="fas fa-info-circle red" tooltip="{{candidate.nameWarning}}" container="body"></i>
                                <span tooltip="{{candidate.name}}" id="candidateName" container="body"
                                      (click)="launchActionsModal('profile')">{{candidate.name}}</span>
                                <sup *ngIf="candidate.fromOtherSource" placement="bottom" container="body"
                                     [tooltip]="candidate.otherSourceNote">
                                    <strong>O</strong>
                                </sup>
                                <sup *ngIf="candidate.referred" placement="bottom"
                                     container="body"
                                     [tooltip]="'Source: Referral<br>Name: ' + candidate.referrerName + ' <br>Email: ' + candidate.referrerEmail">
                                    <strong>R</strong>
                                </sup>
                            </span>
                            <app-candidate-card-icons
                                *ngIf="!loadingFlag"
                                context="candidateCard"
                                [candidate]="candidate"
                                [candidateAdditionalDetails]="candidate.candidateAdditionalDetailsCard"
                                (launchModal)="launchActionsModal('updateContact')"
                                [candidateSalaryDurationOptions]="salaryDurationOptions"
                                [jobTypeList]="jobTypeList"
                                (launchClientReviewModal)="launchActionsModal('clientReview')">
                            </app-candidate-card-icons>
                            <span class="candidate-card-availability-date" *ngIf="candidate.availabilityDate !== null">
                                <span placement="top" tooltip="Candidate Availability Date :   {{ candidate.availabilityDate | fourDotFiveDateFormatPipe }}" container="body" class="cursor-pointer">
                                    <i class="fas fa-business-time"></i>
                                </span>
                            </span>
                        </div>
                        <div class="candidate-card-detail-div candidate-card-contact-detail-div">
                            <span>
                                <span *ngIf="!candidate.conflictPhoneNumber && !candidate.inCompletePhoneNumber" class="cursor-pointer">
                                    <i class="fa fa-phone mr-1"></i>
                                    <span>{{candidate.mobilephone}}</span>
                                </span>
                                <span *ngIf="candidate.conflictPhoneNumber || candidate.inCompletePhoneNumber">
                                    <span class="fa-stack fa" *ngIf="candidate.conflictPhoneNumber" placement="top" tooltip="Phone Number in conflict. Update contact details." container="body">
                                        <i class="fa fa-phone fa-stack-1x"></i>
                                        <i class="fa fa-exclamation fa-stack-2x red"></i>
                                    </span>
                                    <span class="fa-stack fa" *ngIf="candidate.inCompletePhoneNumber" placement="top" tooltip="Phone Number missing. Update contact details." container="body">
                                        <i class="fa fa-phone fa-stack-1x"></i>
                                        <i class="fa fa-ban fa-stack-2x red"></i>
                                    </span>
                                </span>
                            </span>
                            <span class="candidate-card-email pull-right">
                                <span *ngIf="!candidate.conflictEmail && !candidate.inCompleteEmail" placement="top" tooltip="Email {{candidate.email}}" container="body" class="cursor-pointer" style="margin-left: 10px;">
                                    <a (click)="launchActionsModal('emailDocument', 'email')">
                                        <i class="fa fa-envelope"></i>
                                    </a>
                                </span>
                                <span *ngIf="candidate.conflictEmail || candidate.inCompleteEmail">
                                    <span class="fa-stack fa" style="height: 1.5em" *ngIf="candidate.conflictEmail" placement="top" tooltip="Email in conflict. Update contact details." container="body">
                                        <i class="fa fa-envelope fa-stack-1x"></i>
                                        <i class="fa fa-exclamation fa-stack-2x red"></i>
                                    </span>
                                    <span class="fa-stack fa" style="height: 1.5em" *ngIf="candidate.inCompleteEmail" placement="top" tooltip="Email missing. Update contact details." container="body">
                                        <i class="fa fa-envelope fa-stack-1x"></i>
                                        <i class="fa fa-ban fa-stack-2x red"></i>
                                    </span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
                <div *ngIf="candidate.bestMatchId !== null && !showFilledOrJoinedOnCard">
                    <div class="clearfix">
                        <div class="pull-left candidate-card-detail-left clearfix">
                            <div class="pull-left cursor-pointer">
                                <span tooltip="Job Title of Best Job Match" placement="top" container="body" (click)="launchActionsModal('bestMatchJobProfile')">{{candidate.bestMatchJobTitle | truncatePipe:18}}</span>
                                <span *ngIf="candidate.bestMatchJobTitle?.length > 18" tooltip="{{candidate.bestMatchJobTitle}}" container="body" placement="top">...</span>
                            </div>
                            <div class="pull-left" style="padding-left:5px" tooltip="Job Match Rank among Candidate's Job Matches" container="body" placement="top">(#{{candidate.jobMatchRank}})</div>
                        </div>
                        <div class="candidate-card-detail-div pull-right text-right candidate-card-detail-right">
                            <div class="d-flex pull-right">
                                <span tooltip="Manual Match" container="body" class="candidate-card-manual-match">
                                    <i class="fas fa-hand-paper" *ngIf="!candidate.autoJobMatch"></i>
                                </span>
                                <span tooltip="Automated Match" container="body" class="mr-2 candidate-card-manual-match">
                                    <i class="fa fa-cogs fa-sm" *ngIf="candidate.autoJobMatch"></i>
                                </span>
                                <div *ngIf="candidate.jobLeftDate === null" tooltip="Job Match Date of Best Job Match" placement="top" container="body">{{candidate.bestMatchJobDate | fourDotFiveDateFormatPipe}}</div>
                                <div *ngIf="candidate.jobLeftDate !== null" tooltip="Job Left Date" placement="top" container="body">{{candidate.jobLeftDate | fourDotFiveDateFormatPipe}}</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="candidate-card-detail-div" tooltip="Requisition Number of Best Job Match" container="body" placement="top">{{candidate.bestMatchJobRequisitionNum}}</div>
                    </div>
                    <div class="clearfix">
                        <div class="pull-left candidate-card-detail-left clearfix">
                            <div class="pull-left">
                                <span tooltip="{{clientOrBuLabel}} of Best Job Match" container="body" placement="top">{{candidate.bestMatchClientName | truncatePipe:15}}</span>
                                <span *ngIf="candidate.bestMatchClientName?.length > 15" container="body" tooltip="{{candidate.bestMatchClientName}}" placement="top">...</span>
                            </div>
                        </div>
                        <div *ngIf="candidate.lastModifiedDate !== null" class="candidate-card-detail-div pull-right text-right candidate-card-detail-right" tooltip="Last Modified Date" placement="top" container="body">{{candidate.lastModifiedDate | fourDotFiveDateFormatPipe}}</div>
                    </div>
                    <div class="clearfix">
                        <div tooltip="Status of Best Job Match" container="body" placement="top" class="candidate-card-detail-div pull-left candidate-card-detail-left">{{candidate.bestMatchJobCurrentState}}</div>
                        <div tooltip="Days since the candidate was added" container="body" placement="top" class="candidate-card-detail-div pull-right text-right candidate-card-detail-right">{{candidate.noOfDaysSinceAdded}} days</div>
                    </div>
                    <div class="clearfix" *ngIf="candidateType == 'VENDOR_CANDIDATES'">
                        <div tooltip="Vendor" container="body" placement="top" class="candidate-card-detail-div pull-left candidate-card-detail-left">{{candidate.vendorName}}</div>
                    </div>
                </div>
                <div *ngIf="candidate.candidateStatus === 'INERT' && candidate.bestMatchId == null" class="inert-candidate -current-job-details">
                    <div>
                        <b>Latest Job Details</b>
                    </div>
                    <div *ngIf="showCurrentJobDetails">
                        <div class="clearfix">
                            <div class="pull-left candidate-card-detail-left clearfix">
                                <div class="pull-left cursor-pointer">
                                    <span tooltip="{{candidate.currentJobTitleTooltip}}" container="body">{{candidate.currentJobTitle | truncatePipe:26}}</span>
                                    <span *ngIf="candidate.currentJobTitle?.length > 26">...</span>
                                </div>
                            </div>
                            <div *ngIf="candidate.jobLeftDate !== null" class="candidate-card-detail-div pull-right text-right candidate-card-detail-right" tooltip="Job Left Date" placement="top" container="body">{{candidate.jobLeftDate | fourDotFiveDateFormatPipe}}</div>
                        </div>
                        <div class="">
                            <span tooltip="{{candidate.currentJobCompanyNameTooltip}}" container="body">{{candidate.currentJobCompanyName | truncatePipe:20}}{{candidate.currentJobCompanyName?.length > 20 ? '...' : ''}}</span>
                            <span tooltip="Last Modified Date" container="body" class="pull-right">{{candidate.lastModifiedDate | fourDotFiveDateFormatPipe}}</span>
                        </div>
                        <div class="text-overflow-ellipsis">
                            <span tooltip="{{candidate.currentJobLocationToolTip}}" container="body">{{candidate.currentJobLocation}}</span>
                            <div tooltip="Days since the candidate was added" container="body" placement="top" class="candidate-card-detail-div pull-right text-right candidate-card-detail-right">{{candidate.noOfDaysSinceAdded}} days</div>
                        </div>
                    </div>
                    <div *ngIf="!showCurrentJobDetails">
                        <div class="clearfix" style="padding-top:20px">
                            <div class="pull-left candidate-card-detail-left clearfix">
                                <div class="pull-left">
                                    No Job Details Available.
                                </div>
                            </div>
                            <div *ngIf="candidate.lastModifiedDate !== null" class="candidate-card-detail-div pull-right text-right candidate-card-detail-right" tooltip="Last Modified Date" placement="top" container="body">{{candidate.lastModifiedDate | fourDotFiveDateFormatPipe}}</div>
                        </div>
                        <div tooltip="Days since the candidate was added" placement="top" container="body" class="candidate-card-detail-div pull-right text-right candidate-card-detail-right">{{candidate.noOfDaysSinceAdded}} days</div>
                    </div>

                    <div *ngIf="candidateType == 'VENDOR_CANDIDATES'">
                        <div tooltip="Vendor" container="body" placement="top" class="candidate-card-detail-div pull-left candidate-card-detail-left" style="position:relative; top: 9px; height: 22px;">{{candidate.vendorName}}</div>
                    </div>
                </div>
                <div *ngIf="showFilledOrJoinedOnCard">
                    <div class="clearfix">
                        <div class="pull-left candidate-card-detail-left clearfix">
                            <div class="pull-left cursor-pointer">
                                <span tooltip="Job Title of {{filledOrJoinedText}}ed Job Match" container="body" placement="top" (click)="launchActionsModal('bestMatchJobProfile')">{{candidate.filledOrJoinedMatchJobTitle | truncatePipe:18}}</span>
                                <span *ngIf="candidate.filledOrJoinedMatchJobTitle?.length > 18" tooltip="{{candidate.filledOrJoinedMatchJobTitle}}" container="body" placement="top">...</span>
                            </div>
                            <div class="pull-left" style="padding-left:5px" tooltip="Job Match Rank among Candidate's Job Matches" placement="top" container="body">(#{{candidate.joinedOrFilledJobMatchRank}})</div>
                        </div>
                        <div class="candidate-card-detail-div pull-right text-right candidate-card-detail-right" tooltip="{{filledOrJoinedText}} Date" container="body" placement="top">{{candidate.filledOrJoinedMatchJobDate | fourDotFiveDateFormatPipe}}</div>
                    </div>
                    <div>
                        <div class="candidate-card-detail-div" tooltip="Requisition Number of {{filledOrJoinedText}}ed Job Match" container="body" placement="top">{{candidate.filledOrJoinedMatchJobRequisitionNum}}</div>
                    </div>
                    <div class="clearfix">
                        <div class="pull-left candidate-card-detail-left clearfix">
                            <div class="pull-left">
                                <span tooltip="{{clientOrBuLabel}} of {{filledOrJoinedText}}ed Job Match" container="body" placement="top">{{candidate.filledOrJoinedMatchClientName | truncatePipe:15}}</span>
                                <span *ngIf="candidate.filledOrJoinedMatchClientName?.length > 15" tooltip="{{clientOrBuLabel}} of {{filledOrJoinedText}}ed Job Match: {{candidate.filledOrJoinedMatchClientName}}" container="body" placement="top">...</span>
                            </div>
                        </div>
                        <div *ngIf="candidate.lastModifiedDate !== null" class="candidate-card-detail-div pull-right text-right candidate-card-detail-right" tooltip="Last Modified Date" container="body" placement="top">{{candidate.lastModifiedDate | fourDotFiveDateFormatPipe}}</div>
                    </div>
                    <div class="clearfix">
                        <div tooltip="Status of {{filledOrJoinedText}}ed Job Match" placement="top" container="body" class="candidate-card-detail-div pull-left candidate-card-detail-left">{{candidate.filledOrJoinedMatchJobCurrentState}}</div>
                        <div tooltip="Days since the candidate was added" placement="top" container="body" class="candidate-card-detail-div pull-right text-right candidate-card-detail-right">{{candidate.noOfDaysSinceAdded}} days</div>
                    </div>
                    <div class="clearfix" *ngIf="candidateType == 'VENDOR_CANDIDATES'">
                        <div tooltip="Vendor" container="body" placement="top" class="candidate-card-detail-div pull-left candidate-card-detail-left">{{candidate.vendorName}}</div>
                    </div>
                </div>
            </div>
            <div class="profile-box-content clearfix">
                <ul class="menu-items">
                    <li>
                        <div class="candidate-card-popovers-container">
                            <div class="col-xs-4">
                                <div class="text-center candidate-card-footer-section">
                                    <a href="javascript:void(0)" [ngClass]="{'candidate-card-no-longer-match-error-2': candidate.noLongerMatchCount > 0}" *ngIf="isUserAdmin" class="clearfix candidate-card-job-matches-link pointer" popoverTitle="Job Matches"
                                        placement="{{jobMatchesPopoverPosition}}" [popover]="jobMatchesPopover" [outsideClick]="true"
                                        containerClass="candidate-card-job-matches-popover" triggers="click" container="body"
                                        #jobMatchesPopoverDirective="bs-popover">
                                        <span [ngClass]="{'candidate-card-no-longer-match-error': candidate.noLongerMatchCount > 0}" class="pull-left" tooltip="Job Matches" container="body">
                                            <i class="fa fa-briefcase fa-lg"></i>
                                            <span>{{candidate.totalJobMatchCount}}</span>
                                        </span>
                                    </a>
                                    <a href="javascript:void(0)" [ngClass]="{'candidate-card-no-longer-match-error-2': candidate.noLongerMatchCount > 0}" *ngIf="!isUserAdmin" class="clearfix candidate-card-job-matches-link pointer" popoverTitle="Job Matches"
                                        placement="{{jobMatchesPopoverPosition}}" [popover]="jobMatchesPopover" [outsideClick]="true"
                                        containerClass="candidate-card-job-matches-popover" triggers="click" container="body"
                                        #jobMatchesPopoverDirective="bs-popover">
                                        <span [ngClass]="{'candidate-card-no-longer-match-error': candidate.noLongerMatchCount > 0}" class="pull-left candidate-card-job-matches-count" tooltip="Accessible Job Matches / All Job Matches" container="body">
                                            <i class="fa fa-briefcase fa-lg"></i>
                                            <span>{{candidate.jobMatchesCount}} / {{candidate.totalJobMatchCount}}</span>
                                        </span>
                                    </a>
                                </div>
                            </div>
                            <div class="col-xs-4">
                                <div class="text-center">
                                    <img src="assets/app-content/img/people/4dot5-default-no-profile-pic.jpg"
                                         alt="{{candidate.bestMatchRecruiterName}}"
                                         class="candidate-card-recruiter-img img-responsive"/>
                                    <span *ngIf="candidate.recruitersList?.length > 0" class="candidate-card-recruiter-count pointer"
                                          placement="top" [popover]="recruitersPopover" [outsideClick]="true"
                                          containerClass="candidate-card-recruiters-popover" triggers="click" container="body">
                                        +{{candidate.recruitersList.length}}
                                    </span>
                                    <span class="candidate-card-recruiter-name" tooltip="{{candidate.bestMatchRecruiterName}}" container="body">{{candidate.bestMatchRecruiterName}}</span>
                                </div>
                            </div>
                            <div class="col-xs-4">
                                <div class="text-center candidate-card-footer-section">
                                    <div class="btn-group dropdown">
                                        <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">Actions</button>
                                        <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <span class="caret"></span> <span class="sr-only"></span>
                                        </button>
                                        <ul class="dropdown-menu dropdown-menu-right p-0" role="menu">
                                            <li role="menuitem" class="drop-down-action" *ngIf="!(candidate.candidateStatus === 'INERT')">
                                                <a href="javascript:void(0)" (click)="launchCommunicationModal(false)">Communications</a>
                                            </li>
                                            <li role="menuitem" *ngIf="!(candidate.candidateStatus === 'INERT')">
                                                <a href="javascript:void(0)" (click)="launchNotesModal()">Notes</a>
                                            </li>
                                            <li role="menuitem" class="drop-down-action" *ngIf="candidateType == 'OWN_CANDIDATES'">
                                                <a href="javascript:void(0)" (click)="launchActionsModal('availability')">Set Availability Date</a>
                                            </li>
                                            <li role="menuitem" *ngIf="candidate.jobLeftActionAvailable">
                                                <a href="javascript:void(0)" (click)="launchActionsModal('jobLeft')" class="action-danger">Job Left</a>
                                            </li>
                                            <li role="menuitem" class="drop-down-action" *ngIf="candidate.showUploadResumeAction">
                                                <a href="javascript:void(0)" (click)="launchActionsModal('uploadResume')">Upload Resume</a>
                                            </li>
                                            <li role="menuitem" class="drop-down-action"
                                                *ngIf="(isUserAdmin && candidate.totalJobMatchCount > 0) || (!isUserAdmin && candidate.jobMatchesCount > 0)">
                                                <a href="javascript:void(0)" (click)="launchActionsModal('sendOutreach')">Send Candidate Outreach</a>
                                            </li>
                                            <li role="menuitem" class="border-orange"
                                                *ngIf="candidate.showUploadResumeAction && (isSuperUser || is4dot5UserAdmin)">
                                                <a href="javascript:void(0)" (click)="launchActionsModal('runCandidateScore')">Run Candidate Score</a>
                                            </li>
                                            <li role="menuitem" *ngIf="!candidate.jobLeftActionAvailable" class="drop-down-action">
                                                <a href="javascript:void(0)" (click)="launchActionsModal('doNotHire')" class="action-danger">Do Not Hire</a>
                                            </li>
                                            <li role="menuitem" class="drop-down-action" *ngIf="candidateType == 'OWN_CANDIDATES'">
                                                <a href="javascript:void(0)" (click)="launchActionsModal('delete')" class="action-danger">Delete</a>
                                            </li>
                                            <li role="menuitem" class="drop-down-action" *ngIf="candidate.candidateStatus === 'INERT' && candidateType == 'VENDOR_CANDIDATES'">
                                                <a href="javascript:void(0)">No Actions Available!</a>
                                            </li>
                                          </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <!-- Candidate card view skeleton -->
    <div *ngIf="loadingFlag && candidateType=='OWN_CANDIDATES'"
        class="main-box candidate-card-internal-card p-3 d-flex flex-column justify-content-between skeleton-container" style="height:247px;">
        <div class="d-flex flex-column skeleton-container">
            <div class="skeleton-heading width-75 skeleton-loading my-0 mb-2"></div>
            <div class="skeleton-paragraph width-50 skeleton-loading"></div>
        </div>
        <div class="d-flex justify-content-between skeleton-container">
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
        </div>
        <div class="d-flex justify-content-between skeleton-container">
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
        </div>
        <div class="d-flex justify-content-between skeleton-container">
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
        </div>
        <div class="d-flex justify-content-between skeleton-container">
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
        </div>
        <div class="d-flex justify-content-between align-items-center skeleton-container">
            <div class="skeleton-paragraph width-50 skeleton-loading"></div>
            <div class="skeleton-heading width-25 skeleton-loading my-0"></div>
        </div>
    </div>
    <div *ngIf="loadingFlag && candidateType=='VENDOR_CANDIDATES'"
        class="main-box candidate-card-vendor-card p-3 d-flex flex-column justify-content-between skeleton-container" style="height:260px;">
        <div class="d-flex flex-column skeleton-container">
            <div class="skeleton-heading width-75 skeleton-loading my-0 mb-2"></div>
            <div class="skeleton-paragraph width-50 skeleton-loading"></div>
        </div>
        <div class="d-flex justify-content-between skeleton-container">
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
        </div>
        <div class="d-flex justify-content-between skeleton-container">
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
        </div>
        <div class="d-flex justify-content-between skeleton-container">
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
        </div>
        <div class="d-flex justify-content-between skeleton-container">
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
            <div class="skeleton-paragraph width-25 skeleton-loading"></div>
        </div>
        <div class="d-flex justify-content-between align-items-center skeleton-container">
            <div class="skeleton-paragraph width-50 skeleton-loading"></div>
            <div class="skeleton-heading width-25 skeleton-loading my-0"></div>
        </div>
    </div>
</div>

<div *ngIf="isRowViewActive" class="mb-2">
    <div *ngIf="!loadingFlag" class="row candidate-card-row-view-container"
        [ngClass]="{'candidate-card-vendor-card-row-view': candidateType === 'VENDOR_CANDIDATES'}">
        <div class="col-xs-12 px-4 d-flex flex-row align-items-center justify-content-between candidate-card-row-view-heading"
            [ngClass]="{'candidate-card-active-bg': candidate.candidateActive,
            'candidate-card-passive-bg': candidate.candidatePassive,
            'candidate-card-inert-bg': candidate.candidateInert,
            'candidate-card-filled-joined-bg': candidate.anyJobMatchFilledOrJoined || candidate.candidateFilledOrJoinedToOwnJob}">
            <div class="col-xs-12 px-0 d-flex flex-row align-items-center text-overflow-ellipsis" style="min-width: 300px;">
                <div class="d-flex flex-row text-overflow-ellipsis">
                    <div class="px-0 d-flex">
                        <div class="d-flex align-items-center">
                            <img src="assets/app-content/img/people/4dot5-default-no-profile-pic.jpg"
                                alt="{{candidate.name}}" width="50px" height="50px"
                                class="candidate-card-row-view-img pull-left" />
                        </div>
                    </div>
                    <div class="d-flex flex-column text-overflow-ellipsis pl-3">
                        <div class="d-flex flex-row align-items-center text-overflow-ellipsis">
                            <div class="my-1 cursor-pointer d-flex justify-content-start text-overflow-ellipsis">
                                <div class="candidate-name-row-view font-bold text-overflow-ellipsis">
                                    <i *ngIf="candidate.nameWarning !== ''" class="fas fa-info-circle red" [adaptivePosition]="false"
                                        tooltip="{{candidate.nameWarning}}" placement="top" container="body"></i>
                                    <span tooltip="{{candidate.name}}" id="candidateName"
                                        container="body" placement="top" [adaptivePosition]="false"
                                        (click)="launchActionsModal('profile')">{{candidate.name}}</span>
                                </div>
                                <div class="font-bold candidate-name-row-view-status pl-1">
                                    <span *ngIf="candidate.fromOtherSource" placement="bottom"
                                        container="body" [tooltip]="candidate.otherSourceNote" [adaptivePosition]="false">
                                        <strong>O</strong>
                                    </span>
                                    <span *ngIf="candidate.referred" placement="bottom"
                                        container="body" [adaptivePosition]="false"
                                        [tooltip]="'Source: Referral<br>Name: ' + candidate.referrerName + ' <br>Email: ' + candidate.referrerEmail">
                                        <strong>R</strong>
                                    </span>
                                </div>
                                <div class="ml-2">
                                    <span tooltip="Update Candidate Details" placement="bottom" container="body" [adaptivePosition]="false" class="">
                                        <i class="fas fa-pencil-alt" (click)="launchActionsModal('updateContact')"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex flex-row align-items-center text-overflow-ellipsis mt-1">
                            <div class="font-bold">
                                <span *ngIf="!candidate.conflictPhoneNumber && !candidate.inCompletePhoneNumber"
                                    placement="top" tooltip="Phone Number: {{candidate.mobilephone}}"
                                    container="body" [adaptivePosition]="false" class="cursor-pointer">
                                    <span class="fa fa-phone mr-1"></span>
                                    <span>{{candidate.mobilephone}}</span>
                                </span>
                                <span *ngIf="candidate.conflictPhoneNumber || candidate.inCompletePhoneNumber">
                                    <span *ngIf="candidate.conflictPhoneNumber" placement="top"
                                        tooltip="Phone Number in conflict. Update contact details."
                                        container="body" [adaptivePosition]="false">
                                        <span class="fa-stack fa">
                                            <i class="fa fa-phone fa-stack-1x"></i>
                                            <i class="fa fa-exclamation fa-stack-2x red"></i>
                                        </span>
                                        <span>Phone Number in conflict.</span>
                                    </span>
                                    <span *ngIf="candidate.inCompletePhoneNumber" placement="top"
                                        tooltip="Phone Number missing. Update contact details."
                                        container="body" [adaptivePosition]="false">
                                        <span class="fa-stack fa">
                                            <i class="fa fa-phone fa-stack-1x"></i>
                                            <i class="fa fa-ban fa-stack-2x red"></i>
                                        </span>
                                        <span>Phone Number missing.</span>
                                    </span>
                                </span>
                            </div>
                            <div class="mx-2">|</div>
                            <div class="text-overflow-ellipsis font-bold">
                                <span *ngIf="!candidate.conflictEmail && !candidate.inCompleteEmail"
                                    placement="bottom" tooltip="Email: {{candidate.email}}"
                                    container="body" [adaptivePosition]="false" class="cursor-pointer">
                                    <a (click)="launchActionsModal('emailDocument', 'email')" style="color: white">
                                        <span class="fa fa-envelope"></span>
                                        <span class="ml-1">{{candidate.email}}</span>
                                    </a>
                                </span>
                                <span *ngIf="candidate.conflictEmail || candidate.inCompleteEmail">
                                    <span *ngIf="candidate.conflictEmail" placement="bottom"
                                        tooltip="Email in conflict. Update contact details."
                                        container="body" [adaptivePosition]="false">
                                        <span class="fa-stack fa">
                                            <i class="fa fa-envelope fa-stack-1x"></i>
                                            <i class="fa fa-exclamation fa-stack-2x red"></i>
                                        </span>
                                        <span>Email in conflict.</span>
                                    </span>
                                    <span *ngIf="candidate.inCompleteEmail" placement="bottom" [adaptivePosition]="false"
                                        tooltip="Email missing. Update contact details." container="body">
                                        <span class="fa-stack fa">
                                            <i class="fa fa-envelope fa-stack-1x"></i>
                                            <i class="fa fa-ban fa-stack-2x red"></i>
                                        </span>
                                        <span>Email missing.</span>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xs-8 col-xl-9 d-flex flex-row flex-wrap text-overflow-ellipsis px-5" style="line-height: 1.7;">
                        <div *ngIf="candidate.currentJobTitle != '-'" class="d-flex flew-row align-items-center text-overflow-ellipsis">
                            <div class="text-overflow-ellipsis font-bold">
                                <span style="font-size: 14px;" tooltip="{{candidate.currentJobTitleTooltip}}" container="body" placement="top" [adaptivePosition]="false">{{candidate.currentJobTitle}}</span>
                                <span *ngIf="candidate.currentJobCompanyName != '-'" tooltip="{{candidate.currentJobCompanyNameTooltip}}" container="body" placement="top" [adaptivePosition]="false">@ {{candidate.currentJobCompanyName}}</span>
                                <span *ngIf="candidate.currentJobDuration != '-'" tooltip="Latest Job Duration" container="body" placement="top" [adaptivePosition]="false">, {{candidate.currentJobDurationText}}</span>
                            </div>
                        </div>
                        <div *ngIf="candidate.totalExperience && candidate.currentJobTitle != '-'" class="mx-2">|</div>
                        <div *ngIf="candidate.totalExperience" class="d-flex flew-row align-items-center text-overflow-ellipsis">
                            <div class="test-nowrap text-overflow-ellipsis" tooltip="Total Experience: {{candidate.totalExperience}} Years" container="body" placement="top" [adaptivePosition]="false">
                                <span><b>Total Experience:</b></span>
                            </div>
                            <div class="ml-2 text-overflow-ellipsis font-bold">
                                <span>{{candidate.totalExperience}} Years</span>
                            </div>
                        </div>

                        <div *ngIf="candidate.currentJobLocation != '-' && (candidate.totalExperience || candidate.currentJobTitle != '-')" class="mx-2">|</div>
                        <div *ngIf="candidate.currentJobLocation != '-'" class="d-flex flew-row align-items-center text-overflow-ellipsis">
                            <div class="test-nowrap text-overflow-ellipsis" tooltip="Current Location: {{candidate.currentJobLocation}}" container="body" placement="top" [adaptivePosition]="false">
                                <span><b>Current Location:</b></span>
                            </div>
                            <div class="ml-2 text-overflow-ellipsis font-bold">
                                {{candidate.currentJobLocation}}
                            </div>
                        </div>
                        <div *ngIf="candidate.availabilityDate && (candidate.currentJobLocation != '-' || candidate.totalExperience || candidate.currentJobTitle != '-')" class="mx-2">|</div>
                        <div *ngIf="candidate.availabilityDate" class="d-flex align-items-center text-overflow-ellipsis">
                            <div class="test-nowrap text-overflow-ellipsis">
                                <span class="position-relative mr-1" tooltip="Candidate Availability Date" container="body"
                                    placement="top" [adaptivePosition]="false">
                                    <i class="fas fa-business-time"></i>
                                </span>
                                <span><b>Availability Date:</b></span>
                            </div>
                            <div class="ml-2 text-overflow-ellipsis font-bold"
                                tooltip="{{ candidate.availabilityDate | fourDotFiveDateFormatPipe }}" container="body"
                                placement="top" [adaptivePosition]="false">
                                <span>{{ candidate.availabilityDate | fourDotFiveDateFormatPipe }}</span>
                            </div>
                        </div>
                        <div *ngIf="candidateType == 'VENDOR_CANDIDATES'
                            && (candidate.currentJobLocation != '-' || candidate.totalExperience
                            || candidate.currentJobTitle != '-' || candidate.availabilityDate)" class="mx-2">|</div>
                        <div *ngIf="candidateType == 'VENDOR_CANDIDATES'" class="d-flex align-items-center text-overflow-ellipsis">
                            <div class="test-nowrap text-overflow-ellipsis">
                                <span tooltip="Vendor" container="body"
                                    placement="top" [adaptivePosition]="false"><b>Vendor:</b></span>
                            </div>
                            <div class="ml-2 text-overflow-ellipsis font-bold"
                                tooltip="{{candidate.vendorName}}" container="body"
                                placement="top" [adaptivePosition]="false">
                                <span>{{ candidate.vendorName }}</span>
                            </div>
                        </div>
                </div>

            </div>

            <div class="d-flex flex-row align-items-center justify-content-end"
                [ngClass]="{'min-width-230': candidate.noLongerMatchCount > 0, 'min-width-210': candidate.noLongerMatchCount == null || candidate.noLongerMatchCount == undefined || candidate.noLongerMatchCount == 0}">
                <div *ngIf="(isSuperUser || is4dot5UserAdmin) && candidate.totalJobMatchReRunCount && candidate.totalJobMatchReRunCount > 0"
                    tooltip="Rerun Scoring" placement="top" class="pr-3 cursor-pointer">
                    <span id="reRunScore" (click)="launchActionsModal('runCandidateScore')">
                        <i class="fas fa-circle-notch" style="color: red; font-size: 14px;"></i>
                    </span>
                </div>
                <div class="pr-3">
                    <div class="candidate-card-popovers-container">
                        <div class="d-flex justify-content-center align-items-center">
                            <a href="javascript:void(0)" *ngIf="isUserAdmin" class="clearfix candidate-card-job-matches-link pointer" popoverTitle="Job Matches"
                                placement="bottom"
                                [popover]="jobMatchesPopover" [outsideClick]="true"
                                containerClass="candidate-card-job-matches-popover" triggers="click" container="body"
                                #jobMatchesPopoverDirective="bs-popover">
                                <span class="pull-left candidate-card-job-matches-count-row-view" [ngClass]="{'candidate-card-no-longer-match-error-row-view': candidate.noLongerMatchCount > 0}"
                                    tooltip="Job Matches" container="body">
                                    <i class="fa fa-briefcase fa-lg"></i>
                                    <span>{{candidate.totalJobMatchCount}}</span>
                                </span>
                            </a>
                            <a href="javascript:void(0)" *ngIf="!isUserAdmin" class="clearfix candidate-card-job-matches-link pointer" popoverTitle="Job Matches"
                                placement="bottom"
                                [popover]="jobMatchesPopover" [outsideClick]="true"
                                containerClass="candidate-card-job-matches-popover" triggers="click" container="body"
                                #jobMatchesPopoverDirective="bs-popover">
                                <span class="pull-left candidate-card-job-matches-count-row-view" [ngClass]="{'candidate-card-no-longer-match-error-row-view': candidate.noLongerMatchCount > 0}"
                                    tooltip="Accessible Job Matches / All Job Matches"
                                    container="body">
                                    <i class="fa fa-briefcase fa-lg"></i>
                                    <span>{{candidate.jobMatchesCount}} /
                                        {{candidate.totalJobMatchCount}}</span>
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="pr-2">
                    <div tooltip="Peer Email" placement="bottom" container="body" class="pull-right candidate-job-card-notification-icon">
                        <a class="btn" (click)="launchActionsModal('emailDocument')" style="position:relative; color:white;">
                            <i class="fa fa-envelope-open"></i>
                        </a>
                    </div>
                </div>
                <div class="pr-2">
                    <div *ngIf="candidate.candidateStatus !== 'INERT' && candidate.bestMatchId !== null" tooltip="Peer Communication" placement="bottom" container="body" class="pull-right candidate-job-card-notification-icon">
                        <a class="btn" (click)="launchCommunicationModal(true)" style="position:relative">
                            <i class="fa fa-comments"></i>
                            <span class="candidate-card-unread-message-count" *ngIf="candidate.unreadMessageCount > 0">
                                {{candidate.unreadMessageCount}}
                            </span>
                        </a>
                    </div>
                </div>
                <div class="pr-2">
                    <div tooltip="Activity Monitor" placement="bottom" container="body" class="dropdown pull-right candidate-job-card-notification-icon">
                        <a class="btn dropdown-toggle" data-toggle="dropdown" id="activity-list" (click)="showRecentActivities()">
                            <i class="fa fa-list"></i>
                        </a>
                        <ul class="dropdown-menu candidate-activity-list">
                            <app-recent-activities [isActivityClicked]="isActivityClicked" *ngIf="showRecentActivitiesFlag" [activityMap]="activityMap" [recentActivitiesControls]="recentActivitiesControls" context="candidateCard" candidateId="{{candidateInfo.id}}" (showAllCallback)="showAllActivityModal()"></app-recent-activities>
                        </ul>
                    </div>
                </div>
                <div class="pr-2">
                    <div class="dropdown pull-right candidate-card-notification-icon" tooltip="Notifications" placement="bottom" container="body">
                        <a class="btn dropdown-toggle" data-toggle="dropdown" id="dropdownBell" (click)="showNotifications()">
                            <i class="fa fa-bell"></i>
                            <span class="count notification-count" *ngIf="numberOfNewNotifications > 0">{{numberOfNewNotifications}}</span>
                        </a>
                        <ul class="dropdown-menu notifications-list text-dark">
                            <li class="item">
                                <user-notifications *ngIf="showNotificationsFlag" height="200px" width="320px" [searchObject]="notificationsSearchObject" [viewAllFlag]="true" [notificationClicked]="isNotificationClicked"
                                    viewAllMode="modal" context="candidateCard" [userNotificationControls]="userNotificationControls" [(numberOfNewNotifications)]="numberOfNewNotifications"
                                    [showShortNotification]="true" [jobTypeList]="jobTypeList" [salaryDurationOptions]="salaryDurationOptions">
                                </user-notifications>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="profile-box-menu pr-2">
                    <div id="candidate-card-dropdown" class="dropdown candidate-card-actions-row-view profile-box-content">
                        <span data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                            style="font-size: 16px;"
                            class="fas fa-ellipsis-v dropdown-toggle cursor-pointer p-2"
                            tooltip="Actions" placement="bottom" container="body">
                        </span>
                        <ul class="dropdown-menu dropdown-menu-right menu-items p-0" role="menu">
                            <li role="menuitem" class="drop-down-action"
                                *ngIf="!(candidate.candidateStatus === 'INERT')">
                                <a href="javascript:void(0)" (click)="launchCommunicationModal(false)">Communications</a>
                            </li>
                            <li role="menuitem" *ngIf="!(candidate.candidateStatus === 'INERT')">
                                <a href="javascript:void(0)" (click)="launchNotesModal()">Notes</a>
                            </li>
                            <li role="menuitem" class="drop-down-action"
                                *ngIf="candidateType == 'OWN_CANDIDATES'">
                                <a href="javascript:void(0)" (click)="launchActionsModal('availability')">Set Availability Date</a>
                            </li>
                            <li role="menuitem" *ngIf="candidate.jobLeftActionAvailable">
                                <a href="javascript:void(0)" (click)="launchActionsModal('jobLeft')" class="action-danger">Job
                                    Left</a>
                            </li>
                            <li role="menuitem" class="drop-down-action"
                                *ngIf="candidate.showUploadResumeAction">
                                <a href="javascript:void(0)" (click)="launchActionsModal('uploadResume')">Upload Resume</a>
                            </li>
                            <li role="menuitem" class="drop-down-action"
                                *ngIf="(isUserAdmin && candidate.totalJobMatchCount > 0) || (!isUserAdmin && candidate.jobMatchesCount > 0)">
                                <a href="javascript:void(0)" (click)="launchActionsModal('sendOutreach')">Send Candidate Outreach</a>
                            </li>
                            <li role="menuitem" class="border-orange"
                                *ngIf="candidate.showUploadResumeAction && (isSuperUser || is4dot5UserAdmin)">
                                <a href="javascript:void(0)" (click)="launchActionsModal('runCandidateScore')">Run Candidate Score</a>
                            </li>
                            <li role="menuitem" *ngIf="!candidate.jobLeftActionAvailable"
                                class="drop-down-action">
                                <a href="javascript:void(0)" (click)="launchActionsModal('doNotHire')" class="action-danger">Do Not
                                    Hire</a>
                            </li>
                            <li role="menuitem" class="drop-down-action"
                                *ngIf="candidateType == 'OWN_CANDIDATES'">
                                <a href="javascript:void(0)" (click)="launchActionsModal('delete')"
                                    class="action-danger">Delete</a>
                            </li>
                            <li role="menuitem" class="drop-down-action"
                                *ngIf="candidate.candidateStatus === 'INERT' && candidateType == 'VENDOR_CANDIDATES'">
                                <a href="javascript:void(0)">No Actions Available!</a>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
        <div class="col-xs-12 px-4 pt-3 candidate-card-row-view-content"
            [ngClass]="{'candidate-card-row-view-active-bg-content': candidate.candidateStatus === 'ACTIVE',
            'candidate-card-row-view-passive-bg-content': candidate.candidateStatus === 'PASSIVE',
            'candidate-card-row-view-inert-bg-content': candidate.candidateStatus === 'INERT',
            'candidate-card-row-view-filled-joined-bg-content': showFilledOrJoinedOnCard}">
            <div class="col-xs-6 px-0">
                <h4 class="candidate-card-row-view-content-heading my-0 pb-3">Candidate Additional details</h4>
                <app-candidate-card-icons
                    context="candidateCard"
                    [candidate]="candidate"
                    [candidateAdditionalDetails]="candidate.candidateAdditionalDetailsCard"
                    (launchModal)="launchActionsModal('updateContact')"
                    [candidateSalaryDurationOptions]="salaryDurationOptions"
                    [jobTypeList]="jobTypeList"
                    [isRowViewActive]="isRowViewActive"
                    (launchClientReviewModal)="launchActionsModal('clientReview')">
                </app-candidate-card-icons>
            </div>
            <div class="col-xs-6">
                <h4 class="candidate-card-row-view-content-heading my-0 pb-2">Skills</h4>
                <div class="d-flex flex-column pb-2">
                    <div class="mb-2 d-flex flex-row align-items-center text-overflow-ellipsis max-width-fit-content">
                        <div class="font-bold text-muted" tooltip="Candidate Technical Skills" container="body" placement="top" [adaptivePosition]="false">
                            Technical:
                        </div>
                        <div class="ml-2 mb-0 pr-2 text-overflow-ellipsis font-bold">
                            <div class="d-flex text-overflow-ellipsis">
                                <p *ngFor="let skill of candidate.skills?.technicalSkills | slice:0:5"
                                    class="candidate-card-row-view-items text-overflow-ellipsis mr-1 mb-0"
                                    tooltip="{{skill.competency}} - {{skill.experience | convertDurationInYears}}" container="body" [adaptivePosition]="false"
                                    placement="top"><b>{{skill.competency}}</b><span *ngIf="skill.experience"> - {{skill.experience | convertDurationInYears}}</span>
                                </p>
                                <p *ngIf="!candidate.skills?.technicalSkills || candidate.skills?.technicalSkills.length == 0"
                                    class="candidate-card-row-view-items text-overflow-ellipsis mb-0 px-3">N/A</p>
                            </div>
                        </div>
                    </div>
                    <div class="mb-2 d-flex flex-row align-items-center text-overflow-ellipsis max-width-fit-content">
                        <div class="font-bold text-muted" tooltip="Candidate Operational Skills" container="body" placement="top" [adaptivePosition]="false">
                            Operational:
                        </div>
                        <div class="ml-2 mb-0 pr-2 text-overflow-ellipsis font-bold">
                            <div class="d-flex text-overflow-ellipsis">
                                <p *ngFor="let skill of candidate.skills?.operationalSkills | slice:0:5"
                                    class="candidate-card-row-view-items text-overflow-ellipsis mr-1 mb-0"
                                    tooltip="{{skill.competency}} - {{skill.experience | convertDurationInYears}}" container="body" [adaptivePosition]="false"
                                    placement="top"><b>{{skill.competency}}</b><span *ngIf="skill.experience"> - {{skill.experience | convertDurationInYears}}</span>
                                </p>
                                <p *ngIf="!candidate.skills?.operationalSkills || candidate.skills?.operationalSkills.length == 0"
                                    class="candidate-card-row-view-items text-overflow-ellipsis mb-0 px-3">N/A</p>
                            </div>
                        </div>
                    </div>
                    <div class="mb-2 d-flex flex-row align-items-center text-overflow-ellipsis max-width-fit-content">
                        <div class="font-bold text-muted" tooltip="Candidate Soft Skills" container="body" placement="top" [adaptivePosition]="false">
                            Soft:
                        </div>
                        <div class="ml-2 mb-0 pr-2 text-overflow-ellipsis font-bold">
                            <div class="d-flex text-overflow-ellipsis">
                                <p *ngFor="let skill of candidate.skills?.softSkills | slice:0:5"
                                    class="candidate-card-row-view-items text-overflow-ellipsis mr-1 mb-0"
                                    tooltip="{{skill.competency}} - {{skill.experience | convertDurationInYears}}" container="body" [adaptivePosition]="false"
                                    placement="top"><b>{{skill.competency}}</b><span *ngIf="skill.experience"> - {{skill.experience | convertDurationInYears}}</span>
                                </p>
                                <p *ngIf="!candidate.skills?.softSkills || candidate.skills?.softSkills.length == 0"
                                    class="candidate-card-row-view-items text-overflow-ellipsis mb-0 px-3">N/A</p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-row align-items-center text-overflow-ellipsis max-width-fit-content">
                        <div class="font-bold text-muted" tooltip="Candidate Other Skills" container="body" placement="top" [adaptivePosition]="false">
                            Other:
                        </div>
                        <div class="ml-2 mb-0 pr-2 text-overflow-ellipsis font-bold">
                            <div class="d-flex text-overflow-ellipsis">
                                <p *ngFor="let skill of candidate.skills?.extraSkills | slice:0:5"
                                    class="candidate-card-row-view-items text-overflow-ellipsis mr-1 mb-0"
                                    tooltip="{{skill.competency}} - {{skill.experience | convertDurationInYears}}" container="body" [adaptivePosition]="false"
                                    placement="top"><b>{{skill.competency}}</b><span *ngIf="skill.experience"> - {{skill.experience | convertDurationInYears}}</span>
                                </p>
                                <p *ngIf="!candidate.skills?.extraSkills || candidate.skills?.extraSkills.length == 0"
                                    class="candidate-card-row-view-items text-overflow-ellipsis mb-0 px-3">N/A</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="candidate.candidateStatus !== 'INERT' && candidate.bestMatchId !== null" class="d-flex flex-column pt-2">
                    <div>
                        <h4 class="candidate-card-row-view-content-heading my-0 pb-2">Recruiters</h4>
                    </div>
                    <div class="d-flex flex-row flex-wrap align-items-center">
                        <div class="d-flex flex-row align-items-center candidate-card-row-view-items text-overflow-ellipsis">
                            <div class="best-job-match-heading-row-view font-bold text-nowrap text-muted">
                                <span tooltip="Assigned Recruiter" placement="top" [adaptivePosition]="false"
                                    container="body">Assigned Recruiter:</span>
                            </div>
                            <div class="text-overflow-ellipsis candidate-card-row-view-recruiter font-bold ml-2 pr-2">
                                <span *ngIf="candidate.bestMatchRecruiterName != ''"
                                    tooltip="{{candidate.bestMatchRecruiterName}}"
                                    container="body" placement="top" [adaptivePosition]="false">
                                    {{candidate.bestMatchRecruiterName}}
                                </span>
                                <span *ngIf="candidate.bestMatchRecruiterName == ''">N/A</span>
                            </div>
                        </div>
                        <div class="d-flex flex-row align-items-center candidate-card-row-view-items text-overflow-ellipsis">
                            <div class="best-job-match-heading-row-view font-bold text-nowrap text-muted">
                                <span tooltip="Additional Recruiters" placement="top" [adaptivePosition]="false"
                                    container="body">Additional Recruiters:</span>
                            </div>
                            <div class="text-overflow-ellipsis candidate-card-row-view-recruiter font-bold ml-2 pr-2">
                                <span tooltip="{{candidate.recruiterListMessage}}" placement="top"
                                    container="body" [adaptivePosition]="false">{{candidate.recruiterListMessage}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-xs-12 px-4 pr-2 pt-1 candidate-card-row-view-footer d-flex justify-content-end align-items-center"
        [ngClass]="{'candidate-card-row-view-active-bg-content': candidate.candidateStatus === 'ACTIVE',
            'candidate-card-row-view-passive-bg-content': candidate.candidateStatus === 'PASSIVE',
            'candidate-card-row-view-inert-bg-content': candidate.candidateStatus === 'INERT',
            'candidate-card-row-view-filled-joined-bg-content': showFilledOrJoinedOnCard}">
            <div class="px-0 d-flex flex-row align-items-center text-overflow-ellipsis">
                <div>
                    <span tooltip="Added since" container="body" placement="top" [adaptivePosition]="false">
                        <b class="text-muted">Added since:</b></span>
                </div>
                <div tooltip="{{candidate.noOfDaysSinceAdded}} days" container="body" [adaptivePosition]="false"
                    class="text-overflow-ellipsis font-bold ml-2">
                    {{candidate.noOfDaysSinceAdded}} days
                </div>
            </div>
            <div class="mx-1">|</div>
            <div class="px-0 pr-2 d-flex flex-row align-items-center text-overflow-ellipsis">
                <div>
                    <span tooltip="Last modified date" container="body" placement="top" [adaptivePosition]="false">
                        <b class="text-muted">Last modified date:</b></span>
                </div>
                <div class="text-overflow-ellipsis font-bold ml-2">
                    <div *ngIf="!candidate.lastModifiedDate">
                        N/A
                    </div>
                    <div *ngIf="candidate.lastModifiedDate !== null" class="text-overflow-ellipsis" container="body" placement="top"
                        tooltip="Last Modified Date: {{candidate.lastModifiedDate | fourDotFiveDateFormatPipe}}" [adaptivePosition]="false">
                        {{candidate.lastModifiedDate | fourDotFiveDateFormatPipe}}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Candidate row view skeleton -->
    <div *ngIf="loadingFlag" class="row candidate-card-row-view-container px-4 mb-2">
        <div class="w-100 py-2">
            <div class="d-flex flex-column justify-content-between">
                <div class="d-flex flew-row align-items-center skeleton-container candidate-card-row-view-heading">
                    <div class="skeleton-img-candidate-card skeleton-loading my-0"></div>
                    <div class="d-flex flex-column skeleton-container ml-3">
                        <div class="skeleton-heading width-25 skeleton-loading my-0 mb-3"></div>
                        <div class="skeleton-paragraph width-50 skeleton-loading"></div>
                    </div>
                </div>
                <div class="pt-4 skeleton-container d-flex flew-row candidate-card-row-view-content">
                    <div class="d-flex flex-column skeleton-container pr-3">
                        <div class="skeleton-heading width-25 skeleton-loading my-0 mb-3"></div>
                        <div class="skeleton-paragraph width-50 skeleton-loading mb-3"></div>
                        <div class="skeleton-paragraph width-50 skeleton-loading mb-3"></div>
                        <div class="skeleton-paragraph width-75 skeleton-loading mb-3"></div>
                        <div class="skeleton-paragraph width-75 skeleton-loading mb-3"></div>
                        <div class="skeleton-paragraph width-100 skeleton-loading mb-3"></div>
                    </div>
                    <div class="d-flex flex-column skeleton-container">
                        <div class="skeleton-heading width-25 skeleton-loading my-0 mb-3"></div>
                        <div class="skeleton-paragraph width-50 skeleton-loading mb-3"></div>
                        <div class="skeleton-paragraph width-50 skeleton-loading mb-3"></div>
                        <div class="skeleton-paragraph width-75 skeleton-loading mb-3"></div>
                        <div class="skeleton-paragraph width-75 skeleton-loading mb-3"></div>
                        <div class="skeleton-paragraph width-100 skeleton-loading mb-3"></div>
                    </div>
                </div>
                <div class="pb-3 d-flex align-items-center justify-content-end skeleton-container candidate-card-row-view-footer">
                    <div class="skeleton-paragraph width-25 skeleton-loading"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #jobMatchesPopover>
    <app-candidate-job-matches-popover [jobMatchesFilter]="jobMatchesObject"
        [candidateInfo]="candidate"
        (viewAllJobMatchesCallback)="closeJobMatchesPopoverAndNavigate('jobMatches')"
        (viewAllPossibleJobMatchesCallback)="closeJobMatchesPopoverAndNavigate('possibleJobMatches')"
        (jobCompareLaunchedCallback)="hideJobMatchesPopovers()">
    </app-candidate-job-matches-popover>
</ng-template>

<!-- Recruiters popover -->
<ng-template #recruitersPopover>
    <div class="row candidate-card-recruiters-popover-content-container">
        <div class="text-center"
            [ngClass]="{'col-xs-12': candidate.recruitersList.length==1,
            'col-xs-6': candidate.recruitersList.length<3,
            'col-xs-3': candidate.recruitersList.length>=3 }"
            style="flex-grow: 1" *ngFor="let recruiterName of candidate.recruitersList; trackBy: trackByIndex"
            tooltip="{{recruiterName}}">
            <img src="assets/app-content/img/people/4dot5-default-no-profile-pic.jpg" alt="{{recruiterName}}"
                 class="candidate-card-recruiter-img img-responsive"/>
            <span class="candidate-card-recruiter-name">{{recruiterName}}</span>
        </div>
    </div>
</ng-template>

<!-- Filled/joined popover -->
<ng-template #filledJoinedPopover>
    <div class="row">
        <div class="col-xs-12">
            Req Name: <strong>{{candidate.filledOrJoinedMatchJobTitle}}</strong>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12">
            Req Number: <strong>{{candidate.filledOrJoinedMatchJobRequisitionNum}}</strong>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12">
           Job Match Score: <strong>{{candidate.filledOrJoinedMatchJobScore}}</strong>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12">
           Job Match Rank: <strong>{{candidate.jobMatchRank}}</strong>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12">
           Job Match Date: <strong>{{candidate.filledOrJoinedMatchJobDate | fourDotFiveDateFormatPipe}}</strong>
        </div>
    </div>
    <div class="row" *ngIf="candidate.joinedOrFilledJobLocation != null">
        <div class="col-xs-12">
            Job Location: <strong [innerHTML]="candidate.joinedOrFilledJobLocationHtmlText"></strong>
        </div>
    </div>
</ng-template>
